// The shared valuepath-k8s pool's web config (infra/k8s §18:
//   pulumi stack output stacks_firebase_api_key / _auth_domain / _messaging_sender_id / _web_app_id).
// The fallback when no runtime config is served — local dev (`vite dev`,
// docker-compose). A deployed stack gets its pool from /runtime-config.js, whose
// non-prod default (charts/valuepath-stack/values.yaml app.firebase) is this.

export const firebaseConfig = {
  apiKey: "AIzaSyAwzB4BGMt0aWItGbBmInurm2MUAIlG7uM",
  authDomain: "valuepath-k8s.firebaseapp.com",
  projectId: "valuepath-k8s",
  storageBucket: "valuepath-k8s.firebasestorage.app",
  messagingSenderId: "796250224500",
  appId: "1:796250224500:web:260067a9cfe8971637de21",
  measurementId: "G-XXXXXXXXXX",
};
